import Button from "../../shared/Button";

/**
 * Confirm or cancel one proposed write. The server stored the payload.
 *
 * @param {{ action: { _id: string, summary: string, status?: string, error?: string }, busy?: boolean, onConfirm: Function, onCancel: Function }} props
 */
export default function ConfirmCard({ action, busy = false, onConfirm, onCancel }) {
  const failed = action.status === "failed";
  return (
    <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
      <p className="text-sm text-gray-900">{action.summary}</p>
      {failed && action.error ? (
        <p className="mt-2 text-sm text-red-600">{action.error}</p>
      ) : null}
      {failed ? null : (
        <div className="mt-3 flex gap-2">
          <Button
            type="primary"
            size="sm"
            disabled={busy}
            onClick={() => onConfirm(action)}
          >
            Confirm
          </Button>
          <Button
            type="light"
            size="sm"
            disabled={busy}
            onClick={() => onCancel(action)}
          >
            Cancel
          </Button>
        </div>
      )}
    </div>
  );
}
